<div
  class="eva-markdown-editor"
  [class.eva-markdown-editor--focused]="isFocused"
  [class.eva-markdown-editor--disabled]="disabled"
>
  <!-- Contenteditable WYSIWYG area -->
  <div
    #editorContent
    class="eva-markdown-editor__content"
    [attr.data-placeholder]="placeholder"
    [style.minHeight.px]="minHeight"
    [attr.contenteditable]="disabled ? 'false' : 'true'"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (mousedown)="onEditorMousedown($event)"
    (click)="onEditorClick($event)"
    (mouseup)="onMouseUp()"
    (keyup)="onKeyUp($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
  ></div>

  <!-- Character count -->
  @if (showCount) {
    <span class="eva-markdown-editor__count">{{ characterCount }}</span>
  }

  <!-- Floating toolbar -->
  @if (showToolbar) {
    <div
      class="eva-markdown-editor__toolbar"
      [style.top.px]="toolbarPosition.top"
      [style.left.px]="toolbarPosition.left"
      (mousedown)="$event.preventDefault()"
    >
      <button
        type="button"
        class="eva-markdown-editor__toolbar-btn"
        [class.eva-markdown-editor__toolbar-btn--active]="isFormatActive('bold')"
        title="Gras (Ctrl+B)"
        (click)="applyBold()"
      >
        <strong>B</strong>
      </button>
      <button
        type="button"
        class="eva-markdown-editor__toolbar-btn"
        [class.eva-markdown-editor__toolbar-btn--active]="isFormatActive('italic')"
        title="Italique (Ctrl+I)"
        (click)="applyItalic()"
      >
        <em>I</em>
      </button>

      <span class="eva-markdown-editor__toolbar-separator"></span>

      <button type="button" class="eva-markdown-editor__toolbar-btn" title="Titre" (click)="applyHeading()">
        <span>H</span>
      </button>
      <button type="button" class="eva-markdown-editor__toolbar-btn" title="Liste" (click)="applyList()">
        <ng-icon name="heroListBullet"></ng-icon>
      </button>

      <span class="eva-markdown-editor__toolbar-separator"></span>

      <button type="button" class="eva-markdown-editor__toolbar-btn" title="Code (Ctrl+Shift+C)" (click)="applyCode()">
        <ng-icon name="heroCodeBracket"></ng-icon>
      </button>
      <button type="button" class="eva-markdown-editor__toolbar-btn" title="Lien (Ctrl+K)" (click)="applyLink()">
        <ng-icon name="heroLink"></ng-icon>
      </button>
      <button type="button" class="eva-markdown-editor__toolbar-btn" title="Case à cocher" (click)="applyCheckbox()">
        <ng-icon name="evaCheckSquare"></ng-icon>
      </button>
    </div>
  }

  <!-- Slash command menu -->
  @if (showSlashMenu) {
    <div
      class="eva-markdown-editor__slash-menu"
      [style.top.px]="slashMenuPosition.top"
      [style.left.px]="slashMenuPosition.left"
    >
      @for (cmd of filteredSlashCommands; track cmd.id; let i = $index) {
        <button
          type="button"
          class="eva-markdown-editor__slash-item"
          [class.eva-markdown-editor__slash-item--active]="i === selectedSlashIndex"
          (mousedown)="$event.preventDefault()"
          (click)="applySlashCommand(cmd)"
        >
          <ng-icon [name]="cmd.icon" class="eva-markdown-editor__slash-icon"></ng-icon>
          <div class="eva-markdown-editor__slash-text">
            <span class="eva-markdown-editor__slash-label">{{ cmd.label }}</span>
            <span class="eva-markdown-editor__slash-desc">{{ cmd.description }}</span>
          </div>
        </button>
      }
      @if (filteredSlashCommands.length === 0) {
        <div class="eva-markdown-editor__slash-empty">Aucune commande trouvée</div>
      }
    </div>
  }
</div>
